import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  DxButtonModule, DxCheckBoxModule, DxDataGridModule, DxDrawerModule, DxDropDownBoxModule, DxListModule,
  DxLoadPanelModule, DxResponsiveBoxModule, DxScrollViewModule, DxSelectBoxModule, DxTemplateModule, DxTextBoxModule,
  DxToolbarModule, DxTooltipModule, DxTreeViewModule, DxFormModule, DxDateBoxModule, DxFormComponent, DxRadioGroupModule, DxTextAreaModule,
  DxNumberBoxModule, DxPopupModule, DxAccordionModule, DxValidatorModule, DxSwitchModule, DxTagBoxModule, DxFileUploaderModule, DxToastModule,
  DxValidationSummaryModule, DxPivotGridModule, DxChartModule, DxPieChartModule, DxValidationGroupModule, DxMapModule, DxTabsModule, DxTabPanelModule
} from 'devextreme-angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ScreenService } from './services/screen.service';
import { SideNavOuterToolbarComponent } from './side-nav-outer-toolbar/side-nav-outer-toolbar.component';
import { SideNavigationMenuComponent } from './side-navigation-menu/side-navigation-menu.component';
import { SiteListComponent } from './plant/components/sitelist/sitelist.component';
import { HomeComponent } from './home/home.component';
import { ContractlistComponent } from './contracts/components/contractlist/contractlist.component';
import { ContractService } from './contracts/services/contract.service';
import { IndustyCodesComponent } from './industry-codes/industry-codes.component';
import { IndustyCodesService } from './industry-codes/industry-codes.service';
import { ModifyContractComponent } from './contracts/components/modifycontract/modifycontract.component';
import { NotificationModule } from './common/component/notification/notification.component';
import { TokenInterceptor } from './token.interceptor';
import { PipelinesComponent as PipelineComponent } from './pipelines/pipelines.component';
import { SupplierConnectionComponent } from './pipelines/supplier-connection/supplier-connection.component';
import { CustomerConnectionComponent } from './pipelines/customer-connection/customer-connection.component';
import { PipelineService } from './pipelines/pipelines.service';
import { SupplierConnectionService } from './pipelines/supplier-connection/supplier-connection.service';
import { CustomerConnectionService } from './pipelines/customer-connection/customer-connection.service';
import { HomeService } from './home/home.service';
import { FacilityComponent } from './facility/components/facility.component';
import { FacilityDetailsComponent } from './facility/components/facility-details.component';
import { BusinessPotentialComponent } from './facility/components/business-potential.component'
import { FacilityService } from './facility/services/facility.service'
import { SiteService } from "./plant/services/site.service";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivityProcessFeedstockComponent } from './activity-process-feedstock/activity-process-feedstock.component';
import { ActivityProcessFeedstockService } from './activity-process-feedstock/activity-process-feedstock.service';
import { EquipmentListComponent } from './equipments/components/equipmentlist/equipmentlist.component';
import { DistributorReferralMaintenanceComponent } from './distributor-referral-maintenance/distributor-referral-maintenance.component';
import { ModifyEquipmentComponent } from './equipments/components/modifyequipment/modifyequipment.component';
import { CustomerSiteComponent } from './common/component/customer-site/customer-site.component';
import { DatePipe } from '@angular/common';
import { Utility } from './common/service/utility';
import { ProductionActivityComponent } from './production-activity/production-activity.component';
import { SpecificProcessComponent } from './specific-process/specific-process.component';
import { FeedstockComponent } from './feedstock/feedstock.component';
import { ADService } from './common/service/ad.service'
import { ADUserComponent } from './common/component/ac-user/ad-user.component';
import config from 'devextreme/core/config';
import { UserRoleComponent } from './user-role/user-role.component';
import { EditSiteComponent } from './plant/components/editsite/editsite.component';
import { SiteSummaryComponent } from './site-summary/site-summary.component';
import { LookupService } from './common/service/lookup.service';
import { PlantOwnershipComponent } from './common/component/plant-ownership/plant-ownership.component';
import { GoogleMapsComponent } from './plant/components/googlemaps/googlemaps.component';
import { OkayCanceldialogComponent } from './common/component/okaycanceldialog/okaycanceldialog.component';
import { EditVolumeComponent } from './plant/components/editvolume/editvolume.component';
import { BidCompanySearchComponent } from './facility/components/bidcompany-search.component'
import { GlobalASUForecastReportComponent } from './reports/global-asu-forecast/global-asu-forecast-report.component';
import { O2PortalASUReferenceListComponent } from './reports/o2-portal-asu-reference-list/o2-portal-asu-reference-list.component';
import { O2PortalAwardsByRegionComponent } from './reports/o2-reports/o2-portal-awards-by-region/o2-portal-awards-by-region.component';
import { O2PortalAwardsByProcessComponent } from './reports/o2-reports/o2-portal-awards-by-process/o2-portal-awards-by-process.component';
import { CurrencyConversionComponent } from './facility/components/currency-conversion.component'
import { AllPlantsComponent } from './reports/allplants/allplants.component';
import { O2ReportFiltersComponent } from './reports/o2-reports/o2-report-filters.component';
import { H2ForecastFiltersComponent } from './reports/h2-reports/h2-forecast-filters.component';
import { H2ForecastByRegionComponent } from './reports/h2-reports/h2-forecast-by-region/h2-forecast-by-region.component';
import { O2PortalGlobalAsuAwardsComponent } from './reports/o2-reports/o2-portal-global-asu-awards/o2-portal-global-asu-awards.component';
import { SMRAndASUAwardsReportComponent } from './reports/h2-reports/smr-and-asu-awards-report/smr-and-asu-awards-report.component';
import { CRMDataByZipTerritoryComponent } from './reports/crm-data-by-zip-territory/crm-data-by-zip-territory.component';
import { LocationSnapshotMainComponent } from './reports/location-snapshot/main/main.component';
import { LocationSnapshotService } from './reports/location-snapshot/services/location-snapshot.service';
import { O2PortalAsuAwardsByNominalCapacityComponent } from './reports/o2-reports/o2-portal-asu-awards-by-nominal-capacity/o2-portal-asu-awards-by-nominal-capacity.component';
import { H2ForecastSteamReformerComponent } from './reports/h2-reports/h2-forecast-steam-reformer/h2-forecast-steam-reformer.component';
import { H2GlobalHycoAwardsComponent } from './reports/h2-reports/h2-global-hyco-awards/h2-global-hyco-awards.component';

import { DemandCapacityComponent } from './reports/location-snapshot/demand-capacity/demand-capacity.component';
import { OpportunitiesComponent } from './reports/location-snapshot/opportunities/opportunities.component';
import { OpenLeadsByPlantComponent } from './reports/location-snapshot/open-leads-by-plant/open-leads-by-plant.component';
import { SuspectMapComponent } from './reports/location-snapshot/suspect-map/suspect-map.component';
import { SuspectHeatMapComponent } from './reports/location-snapshot/suspect-heat-map/suspect-heat-map.component';
import { DemandByDistanceComponent } from './reports/location-snapshot/demand-by-distance/demand-by-distance.component';
import { SAPVolumeBetterServedComponent } from './reports/location-snapshot/sap-volume-better-served/sap-volume-better-served.component';
import { SuspectListComponent } from './reports/location-snapshot/suspect-list/suspect-list.component';
import { SuspectsWithContactNamesComponent } from './reports/location-snapshot/suspects-with-contact-names/suspects-with-contact-names.component';
import { ParametersComponent } from './reports/location-snapshot/parameters/parameters.component';
import { O2PortalAsuAwardsByApplicationComponent } from './reports/o2-reports/o2-portal-asu-awards-by-application/o2-portal-asu-awards-by-application.component';
import { O2PortalAsuAwardsByCompetitorComponent } from './reports/o2-reports/o2-portal-asu-awards-by-competitor/o2-portal-asu-awards-by-competitor.component';
import { MvaUploadComponent } from './mva-upload/components/mva-upload.component';
import { TerritoryPostCodeDefsComponent } from './reports/territory-post-code-defs/territory-post-code-defs.component';
import { TerritoryService } from "./reports/territory-post-code-defs/territory.service";
import { Co2BetterServedComponent } from './reports/co2-reports/co2-better-served/co2-better-served.component';
import { H2GlobalSteamReformerComponent } from './reports/h2-reports/h2-global-steam-reformer/h2-global-steam-reformer.component';
import { CrmReportDatagridComponent } from './reports/crm-data-by-zip-territory/crm-report-datagrid/crm-report-datagrid.component';
import { CrmReportCurrentCustComponent } from './reports/crm-data-by-zip-territory/crm-report-current-cust/crm-report-current-cust.component';
import { CO2ReportsService } from "./reports/co2-reports/co2-report.service";
import { O2PortalHycoReportComponent } from './reports/o2-reports/o2-portal-hyco-report/o2-portal-hyco-report.component';
import { O2PortalHycoOneyrAnalysisReportComponent } from './reports/o2-reports/o2-portal-hyco-report/o2-portal-hyco-oneyr-analysis-report/o2-portal-hyco-oneyr-analysis-report.component';
import { O2PortalHycoFiveyrAnalysisReportComponent } from './reports/o2-reports/o2-portal-hyco-report/o2-portal-hyco-fiveyr-analysis-report/o2-portal-hyco-fiveyr-analysis-report.component';
import { O2PortalHycoRegionalAnalysisReportComponent } from './reports/o2-reports/o2-portal-hyco-report/o2-portal-hyco-regional-analysis-report/o2-portal-hyco-regional-analysis-report.component';
import { O2PortalHycoAwardDetailsReportComponent } from './reports/o2-reports/o2-portal-hyco-report/o2-portal-hyco-award-details-report/o2-portal-hyco-award-details-report.component';
import { CrmReportLeadsOpenLostWonComponent } from './reports/crm-data-by-zip-territory/crm-report-leads-open-lost-won/crm-report-leads-open-lost-won.component';
import { RefineryBalanceComponent } from './reports/refinery/refinery-balance/refinery-balance.component';
import { RefineryBalanceBySiteComponent } from './reports/refinery/refinery-balance-by-site/refinery-balance-by-site.component';
import { CO2MapBySapplantComponent } from './reports/co2-reports/co2-map-by-sapplant/co2-map-by-sapplant.component';
import { H2GlobalHycoAwardsSogCompetitorComponent } from './reports/h2-reports/h2-global-hyco-awards-sog-competitor/h2-global-hyco-awards-sog-competitor.component';
import { CrmReportCrmProspectsWith91MAComponent } from './reports/crm-data-by-zip-territory/crm-report-crm-prospects-with91-ma/crm-report-crm-prospects-with91-ma.component';
import { DistanceToPlantComponent } from './reports/distance-to-plant/distance-to-plant.component';
import { DistanceToPlantService } from "./reports/distance-to-plant/distanceToPlantService";
import { TGEEProspectsChemicalsOtherComponent } from './reports/tgee-reports/tgee-prospects-chemicals-other/tgee-prospects-chemicals-other.component';
import { CrmReportCrmSuspectsComponent } from './reports/crm-data-by-zip-territory/crm-report-crm-suspects/crm-report-crm-suspects.component';
import { CrmReportOpportunitiesComponent } from './reports/crm-data-by-zip-territory/crm-report-opportunities/crm-report-opportunities.component';
import { BatchReportsGridComponent } from './reports/batch-reports-grid/batch-reports-grid.component';
import { DetailGridComponent } from './reports/batch-reports-grid/detail-grid/detail-grid.component';
import { CrmBatchReportsComponent } from './reports/crm-data-by-zip-territory/crm-batch-reports/crm-batch-reports.component';
import { TGEEASUManufacturerReportComponent } from './reports/tgee-reports/tgee-asu-map-manufacturer/tgee-asu-map-manufacturer';
import { O2PortalHycoReportService } from "./reports/o2-reports/o2-portal-hyco-report/service/o2-portal-hyco-report-service";
import { AsuSmrFiltersComponent } from './reports/o2-reports/o2-portal-asu-smr-report/asu-smr-filters/asu-smr-filters.component';
import { AsuSmrChartsComponent } from './reports/o2-reports/o2-portal-asu-smr-report/asu-smr-charts/asu-smr-charts.component';
import { AsuSmrDetailsComponent } from './reports/o2-reports/o2-portal-asu-smr-report/asu-smr-details/asu-smr-details.component';
import { APLineGraphComponent } from './reports/o2-reports/o2-portal-asu-smr-report/ap-line-graph/ap-line-graph.component';
import { SuspectsAltHeatMapComponent } from './reports/location-snapshot/suspects-alt-heat-map/suspects-alt-heat-map.component';
import { SuspectHeatMapService } from './reports/location-snapshot/services/suspect-heatmap.service';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';

config({
  editorStylingMode: 'outlined'
});

@NgModule({
  declarations: [
    AppComponent,
    SideNavOuterToolbarComponent,
    SideNavigationMenuComponent,
    SiteListComponent,
    HomeComponent,
    ContractlistComponent,
    IndustyCodesComponent,
    ModifyContractComponent,
    PipelineComponent,
    SupplierConnectionComponent,
    CustomerConnectionComponent,
    FacilityComponent,
    FacilityDetailsComponent,
    BusinessPotentialComponent,
    ActivityProcessFeedstockComponent,
    EquipmentListComponent,
    DistributorReferralMaintenanceComponent,
    ModifyEquipmentComponent,
    CustomerSiteComponent,
    PlantOwnershipComponent,
    ProductionActivityComponent,
    SpecificProcessComponent,
    FeedstockComponent,
    ADUserComponent,
    UserRoleComponent,
    EditSiteComponent,
    SiteSummaryComponent,
    GoogleMapsComponent,
    OkayCanceldialogComponent,
    EditVolumeComponent,
    BidCompanySearchComponent,
    GlobalASUForecastReportComponent,
    O2PortalASUReferenceListComponent,
    O2PortalAwardsByRegionComponent,
    O2PortalAwardsByProcessComponent,
    CurrencyConversionComponent,
    AllPlantsComponent,
    O2ReportFiltersComponent,
    H2ForecastFiltersComponent,
    H2ForecastByRegionComponent,
    O2PortalGlobalAsuAwardsComponent,
    SMRAndASUAwardsReportComponent,
    CRMDataByZipTerritoryComponent,
    LocationSnapshotMainComponent,
    O2PortalAsuAwardsByNominalCapacityComponent,
    LocationSnapshotMainComponent,
    DemandCapacityComponent,
    OpportunitiesComponent,
    OpenLeadsByPlantComponent,
    SuspectMapComponent,
    SuspectHeatMapComponent,
    DemandByDistanceComponent,
    SAPVolumeBetterServedComponent,
    SuspectListComponent,
    SuspectsWithContactNamesComponent,
    ParametersComponent,
    O2PortalAsuAwardsByApplicationComponent,
    O2PortalAsuAwardsByCompetitorComponent,
    MvaUploadComponent,
    H2ForecastSteamReformerComponent,
    H2GlobalSteamReformerComponent,
    H2GlobalHycoAwardsComponent,
    H2GlobalHycoAwardsSogCompetitorComponent,
    TerritoryPostCodeDefsComponent,
    Co2BetterServedComponent,
    CrmReportDatagridComponent,
    CrmReportCurrentCustComponent,
    O2PortalHycoReportComponent,
    O2PortalHycoOneyrAnalysisReportComponent,
    O2PortalHycoFiveyrAnalysisReportComponent,
    O2PortalHycoRegionalAnalysisReportComponent,
    O2PortalHycoAwardDetailsReportComponent,
    CrmReportLeadsOpenLostWonComponent,
    RefineryBalanceComponent,
    RefineryBalanceBySiteComponent,
    CrmReportCrmProspectsWith91MAComponent,
    DistanceToPlantComponent,
    CO2MapBySapplantComponent,
    CrmReportCrmSuspectsComponent,
    TGEEProspectsChemicalsOtherComponent,
    CrmReportOpportunitiesComponent,
    BatchReportsGridComponent,
    DetailGridComponent,
    CrmBatchReportsComponent,
    TGEEASUManufacturerReportComponent,
    AsuSmrFiltersComponent,
    AsuSmrChartsComponent,
    AsuSmrDetailsComponent,
    APLineGraphComponent,
    DemandByDistanceComponent,
    SuspectsAltHeatMapComponent,
    UnauthorizedComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    NotificationModule,
    AppRoutingModule,
    HttpClientModule,
    DxSelectBoxModule,
    DxTextBoxModule,
    DxTemplateModule,
    DxDrawerModule,
    DxToolbarModule,
    DxDataGridModule,
    DxListModule,
    DxButtonModule,
    DxTreeViewModule,
    DxTooltipModule,
    DxScrollViewModule,
    DxResponsiveBoxModule,
    DxCheckBoxModule, DxDropDownBoxModule,
    DxLoadPanelModule,
    DxFormModule, DxTextAreaModule,
    FormsModule, DxDateBoxModule,
    DxNumberBoxModule, DxRadioGroupModule,
    DxPopupModule,
    DxAccordionModule,
    DxValidatorModule,
    DxSwitchModule,
    DxTagBoxModule,
    DxFileUploaderModule,
    DxToastModule,
    DxValidationSummaryModule,
    DxPivotGridModule,
    DxChartModule,
    DxPieChartModule,
    DxValidationGroupModule,
    DxMapModule,
    DxTabsModule,
    DxTabPanelModule
  ],
  providers: [ScreenService, ContractService, IndustyCodesService, PipelineService,
    SupplierConnectionService, CustomerConnectionService, HomeService, FacilityService,
    SiteService, ActivityProcessFeedstockService, DatePipe, Utility, ADService, LookupService, LocationSnapshotService,
    TerritoryService, CO2ReportsService, DistanceToPlantService, O2PortalHycoReportService, SuspectHeatMapService,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true }],
  bootstrap: [AppComponent]
})
export class AppModule { }